export default "__VITE_ASSET__2ee6c1f8__"